var alignmentStyle = {"alignLeft":"s7Hqb","textWrapNowrap":"NTHR-","alignRight":"TqxdH","alignCenter":"_01j6d","sizeFullWidth":"JkxNg","renderedInTable":"W9iPj","sizeOriginal":"djFvg","sizeContent":"_6gUhX","sizeSmall":"nw-0U","sizeSmallCenter":"ipdjd","flex":"dXc-a","LEFT":"-HOo6","CENTER":"kvMCg","RIGHT":"u8L7-","AUTO":"jUvau","JUSTIFY":"_1rGMF"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-4bc6d340.js.map
